import { render, staticRenderFns } from "./SNSSetting.vue?vue&type=template&id=1e1a70d8&scoped=true"
import script from "./SNSSetting.vue?vue&type=script&lang=js"
export * from "./SNSSetting.vue?vue&type=script&lang=js"
import style0 from "./SNSSetting.vue?vue&type=style&index=0&id=1e1a70d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a70d8",
  null
  
)

export default component.exports